export const BEvents = Object.freeze({
  notificationsLoaded: Object.freeze({
    instance: new Event('notifications-loaded'),
    name: 'notifications-loaded',
  }),
});
